import React from 'react';
import { Modal } from '@dropbox/dig-components/modal';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@dropbox/dig-components/buttons';
import { messages } from './common/utils';
import SignAiChatItem from './common/sign-ai-chat-item';
import { Text } from '@dropbox/dig-components/typography';

type AIChatModalTypes = {
    iframeUrl: string,
    open: boolean,
    onAbort: () => void,
};

const AIChatModal = ({
  iframeUrl,
  open,
  onAbort,
} : AIChatModalTypes) => {
  const intl = useIntl();
  return (
    <>
      <Modal
        width={1200}
        open={open}
        isCentered
        withCloseButton={intl.formatMessage(messages.close)}
        onRequestClose={onAbort}
        aria-labelledby="SignAiChatModalTitle"
      >
        <Modal.Header hasBottomSpacing="title-standard">
          <Modal.Title id="SignAiChatModalTitle">
            <SignAiChatItem />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='chatModalDiv'>
            <iframe src={iframeUrl} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Text tagName="p">
            <em>
              <FormattedMessage
                id=''
                description='Modal footer disclaimer for AI chat'
                defaultMessage='Please note that the information provided by this chatbot is not intended as legal advice and should not be considered as such. For legal guidance please talk to a lawyer.' />
            </em>
          </Text>
          <Button variant="primary" onClick={onAbort}>
            <FormattedMessage
              id=''
              description='Modal button to close AI chat'
              defaultMessage='Close chat' />
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AIChatModal;
